import { MapPin } from "lucide-react";

const REGIONS = [
  "Heitersheim", "Bad Krozingen", "Buggingen", "Staufen", "Sulzburg",
  "Müllheim", "Neuenburg", "Ballrechten-Dottingen", "Auggen", "Eschbach",
];

export default function Trust() {
  return (
    <section id="einsatzgebiet" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6">
          <div className="text-sm font-medium text-[#6B7F3E] uppercase tracking-wider mb-3">
            Einsatzgebiet
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#1A201A] tracking-tight mb-6">
            Von Heitersheim aus<br />im Markgräflerland.
          </h2>
          <p className="text-[#4A5D4E] max-w-md leading-relaxed">
            Wir sind in der Region rund um Heitersheim tätig. Auf Anfrage auch
            über die genannten Orte hinaus – sprechen Sie uns einfach an.
          </p>
        </div>

        <div className="lg:col-span-6">
          <div className="flex flex-wrap gap-2">
            {REGIONS.map((r) => (
              <span
                key={r}
                className="inline-flex items-center gap-1.5 bg-[#E8ECE1] text-[#2C3E2D] text-sm font-medium px-4 py-2 rounded-full"
              >
                <MapPin className="w-3.5 h-3.5 text-[#6B7F3E]" strokeWidth={2} />
                {r}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
